import React, {Component} from 'react';

import Registry from '../../../registry/index';

class NotEnoughJetons extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        const { close } = this.props;

        let lang = Registry.get('locale');

        return (
            <div className="video-popup not-enough-jetons">
                <div className="header">
                    <div className="icon-close" onClick={() => close()}/>
                    <div className="title">Jetons</div>
                </div>
                <div className="body">
                    <button onClick={() => this.sendQuantityJetons(10)}>
                        <span className="count">+10 </span>
                        <span className="text">{lang.jeton}</span>
                    </button>
                </div>
            </div>
        );
    }
}
export default NotEnoughJetons;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/VideoWindow/NotEnoughTokens.js